import script from "./ViewOccupiersPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewOccupiersPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewOccupiersPage.vue?vue&type=style&index=0&id=29614ae7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29614ae7"]])

export default __exports__